import { render, staticRenderFns } from "./VideosAyudaView.vue?vue&type=template&id=6a19c16a&"
import script from "./VideosAyudaView.vue?vue&type=script&lang=js&"
export * from "./VideosAyudaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports